import { Text } from '@chakra-ui/react';
import type { JunipReviewAttributeRecord } from 'types/reviews';

interface ProductReviewAttributesProps {
  attributeRecords: JunipReviewAttributeRecord[];
}

export function ProductReviewAttributes({
  attributeRecords,
}: ProductReviewAttributesProps) {
  const filteredRecords = attributeRecords.filter(
    (rec) => rec.valueType === 'radio',
  );

  return filteredRecords.map((record) => (
    <Text key={record.id} as="li" size="detail">
      {record.name}: {record.value}
    </Text>
  ));
}
